import httpClient from './_httpClient';

function endPoint(scopeId = null, languageId = null) {
  let endPoint = "";
  let languagePoint = "/";
  languageId!=null ? languagePoint+= "language/" + languageId+'/policy' : languagePoint+="policy";
  scopeId!= null ? endPoint+= "/scopes/" + scopeId + languagePoint: endPoint+=languagePoint;

  return endPoint;
}

const getPoliciesWithScope = (scope_id) => httpClient.get(endPoint(scope_id, null));
const getTermsOrPrivacyPolicyContent = () => httpClient.get(endPoint(null, null));
const updateTermsOrPrivacyPolicyContent = (scope_id, language_id, data) =>
  httpClient.put(endPoint(scope_id, language_id), data);
const getTermsOrPrivacyPolicyByScopeLanguage = (scope_id, language_id) =>
  httpClient.get(endPoint(scope_id, language_id));
const getTermsOrPrivacyPolicyByConnectedScopeAndLanguage = (language_code, type) =>
  httpClient.get(`/policy/${language_code}/${type}`);

export {
  getPoliciesWithScope,
  getTermsOrPrivacyPolicyContent,
  updateTermsOrPrivacyPolicyContent,
  getTermsOrPrivacyPolicyByScopeLanguage,
  getTermsOrPrivacyPolicyByConnectedScopeAndLanguage
}
